var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgramDetailSquiggles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 668,
    viewBox: "0 0 750 668",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_169_464)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 750,
    height: 668,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.934 218.13C613.174 278.333 542.987 428.262 459.568 420.92C315.897 410.166 323.035 222.33 344.563 129.755C465.678 91.8155 547.942 172.864 573.934 218.13ZM573.934 218.13C794.4 265.195 714.272 545.886 636.449 566.14",
    stroke: "#0E22F1",
    strokeOpacity: 0.6,
    strokeDasharray: "6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.587 217.303C493.921 195.956 408.76 320.651 457.16 420.058",
    stroke: "#0E22F1",
    strokeOpacity: 0.6,
    strokeDasharray: "6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.575 130.059C406.102 150.859 514.83 238.204 457.52 421.19",
    stroke: "#0E22F1",
    strokeOpacity: 0.6,
    strokeDasharray: "6 6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.5,
    y: 124.693,
    width: 15,
    height: 15,
    rx: 7.5,
    transform: "rotate(105 353.5 124.693)",
    fill: "white",
    stroke: "#0B23F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.353553,
    y: -0.612372,
    width: 11,
    height: 11,
    rx: 5.5,
    transform: "matrix(0.258819 -0.965926 -0.965926 -0.258819 578.851 224.05)",
    fill: "white",
    stroke: "#0B23F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.098,
    y: 412.453,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(105 473.098 412.453)",
    fill: "white",
    stroke: "#0B23F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641.815,
    y: 563.258,
    width: 8,
    height: 8,
    rx: 4,
    transform: "rotate(105 641.815 563.258)",
    fill: "white",
    stroke: "#0B23F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.934 111.13C613.174 171.333 542.987 321.262 459.568 313.92C315.897 303.166 323.035 115.33 344.563 22.7553C465.678 -15.1845 547.942 65.8636 573.934 111.13ZM573.934 111.13C794.4 158.195 714.272 438.886 636.449 459.14",
    stroke: "#0E22F1",
    strokeOpacity: 0.6,
    strokeDasharray: "6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.587 110.303C493.921 88.9564 408.76 213.651 457.16 313.058",
    stroke: "#0E22F1",
    strokeOpacity: 0.6,
    strokeDasharray: "6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.575 23.0595C406.102 43.859 514.83 131.204 457.52 314.19",
    stroke: "#0E22F1",
    strokeOpacity: 0.6,
    strokeDasharray: "6 6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.5,
    y: 17.6934,
    width: 15,
    height: 15,
    rx: 7.5,
    transform: "rotate(105 353.5 17.6934)",
    fill: "white",
    stroke: "#0B23F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.353553,
    y: -0.612372,
    width: 11,
    height: 11,
    rx: 5.5,
    transform: "matrix(0.258819 -0.965926 -0.965926 -0.258819 578.851 117.05)",
    fill: "white",
    stroke: "#0B23F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.098,
    y: 305.453,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(105 473.098 305.453)",
    fill: "white",
    stroke: "#0B23F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641.815,
    y: 456.258,
    width: 8,
    height: 8,
    rx: 4,
    transform: "rotate(105 641.815 456.258)",
    fill: "white",
    stroke: "#0B23F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7046 404.981C131.7 351.497 294.686 380.488 309.185 462.965C335.982 604.524 152.698 646.245 57.7068 649.41C-10.2872 542.241 46.7078 441.804 83.7046 404.981ZM83.7046 404.981C72.1056 179.847 363.97 184.596 403.676 254.525",
    stroke: "#0E22F1",
    strokeOpacity: 0.6,
    strokeDasharray: "6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9951 405.531C82.9951 488.007 225.483 537.993 308.975 465.514",
    stroke: "#0E22F1",
    strokeOpacity: 0.6,
    strokeDasharray: "6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9971 649.321C62.1634 584.506 118.392 456.877 309.975 464.875",
    stroke: "#0E22F1",
    strokeOpacity: 0.6,
    strokeDasharray: "6 6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.5039,
    y: 642.088,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "white",
    stroke: "#0B23F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 11,
    height: 11,
    rx: 5.5,
    transform: "matrix(-1 0 0 1 88.0039 397.588)",
    fill: "white",
    stroke: "#0B23F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.504,
    y: 452.088,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white",
    stroke: "#0B23F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.504,
    y: 250.088,
    width: 8,
    height: 8,
    rx: 4,
    fill: "white",
    stroke: "#0B23F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_169_464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 750,
    height: 668,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramDetailSquiggles);
export default __webpack_public_path__ + "static/media/program-detail-squiggles.5809fbdf9b1b3ab5d85ea3d0b5c4ef08.svg";
export { ForwardRef as ReactComponent };